import { VIEWS } from "../services/navigation";

const BASE = `${process.env.PUBLIC_URL || ""}/manuals`;

// One manual document per role. Files live in public/manuals/.
export const MANUAL_FILES = {
  [VIEWS.ADMIN]: "PMS_User_Manual_Admin",
  [VIEWS.HR]: "PMS_User_Manual_HR",
  [VIEWS.MANAGEMENT]: "PMS_User_Manual_Management",
  [VIEWS.MANAGER]: "PMS_User_Manual_Manager",
  [VIEWS.EMPLOYEE]: "PMS_User_Manual_Employee",
};

const ORDER = [VIEWS.ADMIN, VIEWS.HR, VIEWS.MANAGEMENT, VIEWS.MANAGER, VIEWS.EMPLOYEE];

// The manuals a user may open = the roles they can switch to (availableViews in RoleContext).
// Employee only -> Employee. HR -> HR + Employee. Admin + HR + Employee -> Admin + HR + Employee.
export const manualsFor = (availableViews) => ORDER.filter((v) => availableViews.includes(v));

// [NEW] Step-by-step demo guide with screenshots (tools/demo), offered to HR and Admin next to their manuals.
export const DEMO_GUIDE = "demo";
export const DEMO_GUIDE_FILE = "PMS_Demo_Guide";
export const showsDemoGuide = (availableViews) => availableViews.includes(VIEWS.HR) || availableViews.includes(VIEWS.ADMIN);
const fileOf = (view) => (view === DEMO_GUIDE ? DEMO_GUIDE_FILE : MANUAL_FILES[view]);

export const pdfUrl = (view) => `${BASE}/${fileOf(view)}.pdf`;
export const docxUrl = (view) => `${BASE}/${fileOf(view)}.docx`;
